import React, {useEffect, useState} from 'react'
import Axios from 'axios'
import { Container, Card, Button, Col, Image, Accordion } from 'react-bootstrap'
import md5 from 'md5';
import { RiDeleteBin6Line, RiPencilLine } from "react-icons/ri";
import { Link, useNavigate} from 'react-router-dom';
import ProfileEditModal from './ProfileEditModal';

export default function Profile(props) {

  const [imageUrl, setImageUrl] = useState();
  const [currentProfile, setCurrentProfile] = useState(props.user);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);

  let navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    fetchGravatar()
  });

  const fetchGravatar = () => {
    let hash = md5(props.user.emailAddress.trim().toLowerCase())
    setImageUrl(`https://www.gravatar.com/avatar/${hash}?s=200`)
    // console.log(hash)
    // Axios.get(`https://www.gravatar.com/${hash}.json`)
    // .then(response => {
    //     console.log(response)
    //     setImageUrl(`https://www.gravatar.com/avatar/${hash}?s=200`)
    // })
    // .catch(error => {
    //     console.log("Error Loading Gravatar Information")
    //     console.log(error)
    //     setImageUrl("/zen-brush-symbol.png")
    // })
  }

  
  return (
    <div className="wrapper">
      <Container>
      <Col sm={5} className="center-form">
        <Card className="text-center">
          <Card.Header as="h4">Profile</Card.Header>
          <Card.Body>
            <Image roundedCircle={true} id="img-profile" src={imageUrl}></Image>
            <Card.Title as="h1">{props.user.firstName}&nbsp;{props.user.lastName}</Card.Title>
            <Card.Text>
              {props.user.emailAddress}<Button className="icons-buttons" variant="link" onClick={handleShow}><RiPencilLine/></Button><br></br>
              <Button className="icons-buttons" variant="link"><Link to="/profile/password">Change password</Link></Button>
            </Card.Text>
            <a href="https://en.gravatar.com/" target="_blank">Change profile image</a>
            {/* <Button className="icons-buttons" variant="link" onClick={() => {props.deleteAccount(props.user._id)}}><RiDeleteBin6Line/></Button> */}
          </Card.Body>
          <Card.Footer className="text-muted">You'll need to login again to see any updates.</Card.Footer>
        </Card>
        <br></br>
        <Accordion >
      <Accordion.Item eventKey="0">
        <Accordion.Header>How to meditate</Accordion.Header>
        <Accordion.Body>
          <li>Wear comfortable clothing,</li>
          <li>Sit somewhere you are comfortable,</li>
          <li>Sit somewhere quiet,</li>
          <li>Make sure the room is in a comfortable temperature,</li>
          <li>Use the timer available inside each meditation,</li>
          <li>Don’t be overly anxious about the time.</li>
          





        </Accordion.Body>
      </Accordion.Item>
     
    </Accordion>

        </Col>
      </Container>

        {
          <ProfileEditModal currentProfile={currentProfile} key={currentProfile._id} profile={currentProfile} show={show}
          onHide={() => handleClose()} setCurrentProfile={setCurrentProfile} handleSuccessMessage={props.handleSuccessMessage} handleErrorMessage={props.handleErrorMessage}></ProfileEditModal>
        }

    </div>
  )
}
